import React, { createContext, useContext, useState, useEffect } from 'react';
import tr from '../locales/tr.json';
import en from '../locales/en.json';

// Dil dosyalarını birleştir
const translations = {
  tr,
  en
};

// Context oluştur
const LanguageContext = createContext();

// Hook oluştur
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

// Provider bileşeni
export const LanguageProvider = ({ children }) => {
  // Varsayılan dil olarak localStorage'dan al veya 'tr' kullan
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage || 'tr';
  });

  // Dil değiştirme fonksiyonu
  const changeLanguage = (language) => {
    setCurrentLanguage(language);
    localStorage.setItem('language', language);
  };

  // Çeviri fonksiyonu
  const t = (key, params = {}) => {
    // Önce flat key olarak dene
    if (translations[currentLanguage] && key in translations[currentLanguage]) {
      let value = translations[currentLanguage][key];
      
      // Parametreleri değiştir (interpolation)
      if (params && typeof value === 'string') {
        Object.keys(params).forEach(paramKey => {
          value = value.replace(new RegExp(`{${paramKey}}`, 'g'), params[paramKey]);
        });
      }
      
      return value || key;
    }
    
    // Nokta notasyonu ile nested key'lere erişim (örn: "common.show")
    const keys = key.split('.');
    let value = translations[currentLanguage];
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        // Çeviri bulunamadıysa key'i döndür
        console.warn(`Translation key not found: ${key} for language: ${currentLanguage}`);
        return key;
      }
    }
    
    let result = value || key;
    
    // Parametreleri değiştir (interpolation)
    if (params && typeof result === 'string') {
      Object.keys(params).forEach(paramKey => {
        result = result.replace(new RegExp(`{${paramKey}}`, 'g'), params[paramKey]);
      });
    }
    
    return result;
  };

  // Context değeri
  const contextValue = {
    currentLanguage,
    changeLanguage,
    t,
    translations: translations[currentLanguage]
  };

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
